import React from "react";
import { Text, Logo, RowContainer } from "../style";
import villager from "../../../static/villager.svg";
import withTurn from "..";
import ChatArea from "../../ChatArea";

const Villager = () => {
  return (
    <>
      <RowContainer>
        <Logo src={villager} alt="logo" />
        <Text>You're a villager</Text>
        <Text>Guess whose the werewolf!</Text>
      </RowContainer>
      <ChatArea />
    </>
  );
};

export default withTurn(Villager);
